import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer } from "ui"
import { HistoryData, TrafficUpdate, transformProperties } from "utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  historyData: HistoryData[]
  trafficUpdates: TrafficUpdate[]
}

const components = {
  HeroBannerHomePage: () => import("./Hero/Hero"),
  powerNumbers: () => import("./Numbers"),
  timeline: () => import("./History/History"),
  fAQ: () => import("./FAQ/FAQ"),
  trafficUpdates: () => import("./TrafficUpdates/TrafficUpdates"),
  bannerModule: () => import("./Services"),
}

export default function Homepage({
  data,
  locale,
  historyData,
  trafficUpdates,
}: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)

  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        // Prefer a stable key from block data, fallback to index
        const blockKey = block.id || block.key || block.blockType + "-" + index

        return (
          <BlockRenderer
            key={blockKey}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={{ historyData, trafficUpdates }}
          />
        )
      })}
    </>
  )
}
